import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _defineProperty from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from '@/mixins/packageTableMixins';
import importResultCom from './components/importResult.vue';
import leftCom from './components/leftCom.vue';
import config from '@/config/index';
import { device_add, device_file_list, device_del, device_update, device_file_import } from '@/api/pests';
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data: function data() {
    var _this2 = this,
        _ref4;

    return {
      setData: null,
      currClientId: null,
      //当前选择的应用id
      form_filter: {
        device_code: null,
        building_name: null,
        device_name: null
      },
      //共用的查询与重置
      topButtonList: [{
        name: '查询',
        type: 'primary',
        method: this.search
      }, {
        name: '重置',
        type: 'error',
        method: this.reset
      }],
      //共用的右侧添加按钮
      topButtonList1: [{
        name: '刷新',
        icon: 'ios-refresh',
        type: 'primary',
        method: this.init
      }],
      reqBase: {
        page: 1,
        page_size: 15,
        project_name: null,
        device_name: null
      },
      reduceheight: 0,
      status: true,
      //是否企业认证
      tableDataList: [],
      getPageTotal: 0,
      operationButtonList: [{
        name: '失败详情',
        type: 'text',
        icon: '',
        method: this.importResult
      }],
      columnsheader: [{
        align: 'center',
        title: '编号',
        minWidth: 80,
        key: 'xuhao'
      }, {
        align: 'center',
        title: '文件名称',
        minWidth: 120,
        key: 'file_name',
        render: function render(h, _ref) {
          var row = _ref.row;
          return h('a', {
            attrs: {
              target: '_blank',
              download: row.file_name,
              href: row.download_url
            }
          }, row.file_name);
        }
      }, {
        align: 'center',
        title: '导入状态',
        minWidth: 120,
        key: 'status',
        render: function render(h, _ref2) {
          var row = _ref2.row;
          var result = '';

          if (row.status === 1) {
            result = "上传成功";
          } else if (row.status === 2) {
            result = "导入中";
          } else if (row.status === 3) {
            result = "导入成功";
          } else if (row.status === 4) {
            result = "部分导入成功";
          } else if (row.status === 5) {
            result = "全部导入失败";
          }

          return h('div', result);
        }
      }, {
        align: 'center',
        title: '导入开始时间',
        minWidth: 120,
        key: 'import_start_time'
      }, {
        align: 'center',
        title: '导入结束时间',
        minWidth: 120,
        key: 'import_end_time'
      }, (_ref4 = {
        align: 'center',
        title: '操作'
      }, _defineProperty(_ref4, "align", 'center'), _defineProperty(_ref4, "minWidth", 190), _defineProperty(_ref4, "key", 'Operating'), _defineProperty(_ref4, "render", function render(h, _ref3) {
        var row = _ref3.row;
        var arr = [];

        if (row.status === 4 || row.status === 5) {
          var _loop = function _loop(i) {
            var list = _this2.operationButtonList[i];
            arr.push(h('Button', {
              style: {
                marginLeft: '5px',
                marginBottom: '3px',
                color: '#2d8cf0'
              },
              props: {
                type: list.type,
                size: list.size ? list.size : 'small'
              },
              on: {
                click: function click() {
                  list.method(row);
                }
              }
            }, list.name));
          };

          for (var i in _this2.operationButtonList) {
            _loop(i);
          }
        }

        return h('div', arr);
      }), _ref4)]
    };
  },
  components: {
    leftCom: leftCom
  },
  computed: {},
  props: {
    reducehe: {},
    code: {}
  },
  methods: {
    /**
     * 导入结果列表
     */
    importResult: function importResult(item) {
      var vm = this;
      var config = {
        loading: true,
        width: 700,
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '5px'
            }
          }, '失败详情'), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h('Divider', {
            style: {
              margin: '8px 0'
            }
          }), h(importResultCom, {
            ref: 'importResultCom',
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              id: item.id
            }
          })]);
        },
        onOk: function onOk() {
          vm.$Modal.remove();
        }
      };
      this.$Modal.success(config);
    },

    /**
     * 导入数据
     */
    importData: function importData() {
      if (!this.reqBase.cate_code) {
        this.$Message.error("请选添加防制分类");
        return false;
      }

      var vm = this;
      var config = {
        loading: true,
        width: 800,
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '5px'
            }
          }, '导入'), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h('Divider', {
            style: {
              margin: '8px 0'
            }
          }), h(importCustom, {
            ref: 'importCustom',
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              projectCode: vm.code,
              cate_code: vm.reqBase.cate_code
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.importCustom;
          obj.checkForm().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              device_file_import(_objectSpread({}, formModel, {
                cate_code: vm.reqBase.cate_code,
                project_code: vm.code
              })).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg = res.errorMsg;
                  vm.$Message.success(_msg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    checkList: function checkList(item) {
      this.$set(this.reqBase, 'cate_code', item.cate_code);
      this.$set(this.reqBase, 'device_name', item.device_name);
      this.init();
    },
    pageSizeChange: function pageSizeChange() {},
    init: function init() {
      var _this3 = this;

      this.tableLoading = true;
      device_file_list(_objectSpread({}, this.reqBase)).then(function (res) {
        _this3.tableLoading = false;
        _this3.tableDataList = [];

        if (res.result === 0) {
          _this3.tableDataList = res.body.list || [];
          _this3.getPageTotal = res.body.total;
        } else {
          _this3.tableDataList = [];
          _this3.getPageTotal = 0;

          _this3.$Message.error(res.errorMsg);
        }
      });
    },
    //新增
    add: function add() {
      var _this4 = this;

      if (!this.reqBase.cate_code) {
        this.$Message.error("请选添加防制分类");
        return false;
      }

      var vm = this;
      var config = {
        loading: true,
        width: 800,
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '5px'
            }
          }, '添加'), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h('Divider', {
            style: {
              margin: '8px 0'
            }
          }), h(addAppCustom, {
            ref: 'addAppCustom',
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              projectCode: _this4.code
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addAppCustom;
          obj.checkForm().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              device_add(_objectSpread({}, formModel, {
                cate_code: vm.reqBase.cate_code
              })).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg2 = res.errorMsg;
                  vm.$Message.success(_msg2);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    search: function search() {
      this.onSearch(this.form_filter);
    },
    reset: function reset() {
      this.form_filter = {
        device_code: null,
        device_name: null,
        building_name: null
      };
      this.search();
    },
    details: function details(row) {
      var vm = this;
      var config = {
        loading: true,
        width: 800,
        okText: '关闭',
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '5px'
            }
          }, '详情'), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h('Divider', {
            style: {
              margin: '8px 0'
            }
          }), h(customDetails, {
            ref: 'customDetails',
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              setData: row
            }
          })]);
        },
        onOk: function onOk() {
          vm.$Modal.remove();
        }
      };
      this.$Modal.success(config);
    },
    edit: function edit(row) {
      var _this5 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 800,
        render: function render(h) {
          return h('div', [h('div', {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, [h('h3', {
            style: {
              width: '100%',
              paddingBottom: '5px'
            }
          }, '编辑'), h('icon', {
            props: {
              type: 'md-close',
              size: '16'
            },
            style: {
              cursor: 'pointer'
            },
            on: {
              'click': function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h('Divider', {
            style: {
              margin: '8px 0'
            }
          }), h(addAppCustom, {
            ref: 'addAppCustom',
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              setData: row,
              projectCode: _this5.code
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addAppCustom;
          debugger;
          obj.checkForm().then(function (req) {
            if (req) {
              //提交请求
              var formModel = obj.formModel;
              device_update(_objectSpread({}, formModel, {
                company_code: row.company_code
              })).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(res.errorMsg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    del: function del(row) {
      var vm = this;
      var config = {
        loading: true,
        title: this.$t('删除'),
        content: this.$t('您确定要删除') + row.device_name + '?',
        onOk: function onOk() {
          var _this = this;

          device_del({
            id: row.id
          }).then(function (res) {
            if (res.result === 0) {
              vm.$Message.success(res.errorMsg);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(res.errorMsg);
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    }
  },
  mounted: function mounted() {
    var params = this.$route.params;
    this.$set(this.reqBase, 'project_code', params.project_code);
    this.$set(this.reqBase, 'cate_code', params.cate_code);
    this.init();
  },
  created: function created() {// this.getPageSizeToStorage();
  }
};